export default __webpack_public_path__ + "./fonts/share.2f484a618f4cfc5b76bb59cce7cf3b15.svg";